import { takeEvery, select, all } from 'redux-saga/effects';
import {
  AuthorizationApi,

  loginAction,

  createLoginSaga, refreshAccessToken,
  RoleNames,
} from '@smorder/logic';

import {
  loadOrders as loadOrdersAction,
  loadOrder as loadOrderAction,
  proceedOrder as proceedOrderAction,
  declineOrder as declineOrderAction,
} from '../reducers/order.reducers';

import {
  loadOrders as loadSignageOrdersAction,
} from '../reducers/signage.reducers';

import { loadOrders, loadOrder, proceedOrder, declineOrder, handleScan } from './order.sagas';
import { loadSignageOrders } from './signage.sagas';

import { closeAlert as closeAlertAction } from '../reducers/alert.reducers';
import { closeAlert } from '../sagas/alert.sagas';

import {
  loadUiOptions as loadUiOptionsAction,
  setPendingScannerInput as setPendingScannerInputAction,
} from '../reducers/app.reducers';

import { loadUiOptions } from '../sagas/app.sagas';

import config from '../../run-config';

import OrderApi from '../api/order';
import SignageApi from '../api/signage';
import AppApi from '../api/app';

const allowedRoles = [RoleNames.Waiter];

const login = createLoginSaga(allowedRoles, [], []);

export default function* rootSaga() {
  let authApi = null;
  let orderApi = null;
  let signageApi = null;
  let appApi = null;

  function* tokenProvider() {
    const { accessToken, refreshToken, expiresAt } = yield select(state => state.authentication);
    return {
      accessToken,
      refreshToken,
      expiresAt,
    };
  }

  function* tokenRefreshTask() {
    return yield refreshAccessToken(authApi);
  }

  function optionProvider() {
    return {
      tokenRefreshTask,
      tokenProvider,
    };
  }

  authApi = new AuthorizationApi(config.apiHost, optionProvider);
  orderApi = new OrderApi(config.apiHost, optionProvider);
  signageApi = new SignageApi(config.apiHost, optionProvider);
  appApi = new AppApi(config.apiHost, optionProvider);

  yield all([
    // auth
    takeEvery(loginAction.INIT, login, authApi),

    // orders
    takeEvery(loadOrdersAction, loadOrders, orderApi),
    takeEvery(loadOrderAction, loadOrder, orderApi),
    takeEvery(proceedOrderAction, proceedOrder, orderApi),
    takeEvery(declineOrderAction, declineOrder, orderApi),

    // alert
    takeEvery(closeAlertAction, closeAlert),

    // signage
    takeEvery(loadSignageOrdersAction, loadSignageOrders, signageApi),

    // app
    takeEvery(loadUiOptionsAction, loadUiOptions, appApi),

    // scanner
    takeEvery(setPendingScannerInputAction, handleScan, orderApi),
  ]);
}
